import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Routes from './routes/MainRoutes';
import { initApp } from './actions/action';
import { LanguageConsumer } from './utils/LanguageContext';
import { connectModal } from './components/Modal';

import logo from './assets/images/logo.png';

const { REACT_APP_PATH } = process.env;

const mapStateToProps = (state) => {
  return {
    state
  };
};

const actions = { initApp };

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

class App extends Component {
  state = {
    loading: false
  };

  componentWillMount = async () => {
    const fectchData = this.props.actions.initApp();
    Promise.all(fectchData).then((res) => {
      this.setState({
        loading: true
      });
    });
    // this.setState({
    //   loading: true
    // });
  };

  componentDidMount = () => {
    // this.setState({
    //   loading: true
    // });
  }

  render() {
    const { loading } = this.state;
    return (
      <LanguageConsumer>
        {props => (
          <div className={`main-app ${props.language}`}>
            <Helmet>
              <title>Bigsilver Manufacturing</title>
              <meta name="description" content="Big Silver was established as a small company in 1993 in a part of Bangkok, the capital of Thailand. With Italian machinery, updated technology and proper know-how: these fundamental factors make Big Silver worldwide accepted in the field of silver chain manufacturing. The company becomes one of the leading manufacturers in the world with large scale production and over 500 items satisfying customers." />
              <meta name="keywords" cpntent="jewelry,silver chain,manufacturers" />
              <meta property="og:title" content="Bigsilver Manufacturing" />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="/" />
              <meta property="og:image" content="favicon.png" />
              <link rel="canonical" href={`${REACT_APP_PATH}/`} />
            </Helmet>
            <div className={`preload-container ${loading ? '' : 'active'}`}>
              <img src={logo} alt="logo" />
            </div>
            <Navigation key={`nav-${loading}`} {...this.props} {...props} />
            <div className="wrapper">
              <Routes {...props} />
            </div>
            <Footer {...props} />
          </div>
        )}
      </LanguageConsumer>
    );
  }
}

// export default connectModal(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectModal(App)));



// WEBPACK FOOTER //
// ./src/App.js